import APIObject from '../object'

export default class Images extends APIObject {
}
